/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DebugService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param on 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAllowDownloadWordOnGet(on: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAllowDownloadWordOnGet(on: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAllowDownloadWordOnGet(on: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAllowDownloadWordOnGet(on: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (on === null || on === undefined) {
            throw new Error('Required parameter on was null or undefined when calling apiAllowDownloadWordOnGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/allowDownloadWord/${encodeURIComponent(String(on))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGetAllConfigGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiGetAllConfigGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiGetAllConfigGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiGetAllConfigGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/GetAllConfig`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param url 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGetFastAPIURLUrlGet(url: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiGetFastAPIURLUrlGet(url: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiGetFastAPIURLUrlGet(url: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiGetFastAPIURLUrlGet(url: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (url === null || url === undefined) {
            throw new Error('Required parameter url was null or undefined when calling apiGetFastAPIURLUrlGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/getFastAPIURL/${encodeURIComponent(String(url))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param url 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiGeturlTLRUrlGet(url: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiGeturlTLRUrlGet(url: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiGeturlTLRUrlGet(url: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiGeturlTLRUrlGet(url: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (url === null || url === undefined) {
            throw new Error('Required parameter url was null or undefined when calling apiGeturlTLRUrlGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/geturlTLR/${encodeURIComponent(String(url))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTestNotificationUserIDGet(userID: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiTestNotificationUserIDGet(userID: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiTestNotificationUserIDGet(userID: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiTestNotificationUserIDGet(userID: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userID === null || userID === undefined) {
            throw new Error('Required parameter userID was null or undefined when calling apiTestNotificationUserIDGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/testNotification/${encodeURIComponent(String(userID))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param on 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTriggerCallBackFromFastOnGet(on: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiTriggerCallBackFromFastOnGet(on: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiTriggerCallBackFromFastOnGet(on: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiTriggerCallBackFromFastOnGet(on: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (on === null || on === undefined) {
            throw new Error('Required parameter on was null or undefined when calling apiTriggerCallBackFromFastOnGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/triggerCallBackFromFast/${encodeURIComponent(String(on))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param on 
     * @param interval 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiTriggerFastServiceOnIntervalGet(on: boolean, interval: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiTriggerFastServiceOnIntervalGet(on: boolean, interval: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiTriggerFastServiceOnIntervalGet(on: boolean, interval: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiTriggerFastServiceOnIntervalGet(on: boolean, interval: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (on === null || on === undefined) {
            throw new Error('Required parameter on was null or undefined when calling apiTriggerFastServiceOnIntervalGet.');
        }

        if (interval === null || interval === undefined) {
            throw new Error('Required parameter interval was null or undefined when calling apiTriggerFastServiceOnIntervalGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/triggerFastService/${encodeURIComponent(String(on))}/${encodeURIComponent(String(interval))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
